import {GetHospital} from './Utils/Utils';

export const DebugMode = false; // window.location.href.includes("localhost:3000");

export const Version = 0.1;

export function GetBaseUrl()
{
    if (DebugMode)
        return "http://localhost:6549/";
        else
        return "https://webserviceslc.hrsj.com.mx/";
}

export function GetBaseUrlApi()
{
    const hindex = GetHospital();

    if (DebugMode)
        return "http://localhost:6549/api/";
        else
        return hindex === 'LC' ? "https://webserviceslc.hrsj.com.mx/sahnet/api/" : "https://webservicesvr.hrsj.com.mx/net/api/";
}

export function GetTitleHospital()
{
    const hindex = GetHospital();

    return hindex === 'LC' ? "Lazaro Cardenas" : "Valle Real";
}

export function GetIndexHospital()
{
    const hindex = GetHospital();

    return hindex === 'LC' ? 0 : 1;
}